import { Box } from './box';

export class BoxSmallUsa2021 extends Box
{
  private static readonly BACK_IMAGE: string =
      'https://resi.puzzleyou.net/images/box-bottom-usa-2021';

  constructor(
      canvas: HTMLCanvasElement,
      svgReference: SVGElement|string,
      options: Object = {})
  {
    const getOrientation = (svgReference): string => {
      let svg = svgReference;
      if (typeof svgReference === 'string') {
        svg = (<any>canvas.getRootNode()).getElementById(svgReference);
      }
      const viewBox = svg.getAttribute('viewBox')
        .split(' ');
      if (parseInt(viewBox[2], 10) > parseInt(viewBox[3], 10)) {
        return 'landscape';
      }
      else {
        return 'portrait';
      }
    };

    const getBackSVG = (orientation: string) => {
      const backSVGContainer = document.createElement('div');
      const backId = 'preview-back-' + Math.random().toString(36).substring(7);

      let width = 620;
      let height = 800;
      if (orientation === 'portrait') {
        width = 800;
        height = 620;
      }
      const backUrl = BoxSmallUsa2021.BACK_IMAGE +
          '?convert=image/jpeg&stretch={"width": "' + width + '"}&orientation='
          + orientation;

      backSVGContainer.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg"
             id="${backId}"
             height="100%"
             width="100%"
             viewBox="0 0 ${height} ${width}">
          <image
             height="100%"
             width="100%"
             x="0"
             y="0"
             xlink:href="${encodeURI(backUrl)}" />
        </svg>
      `;
      return backSVGContainer.querySelector('svg');
    };

    const model = {
      boxTop: {
        position: [
            // Front
            -0.928, -1.347,  0.127,
             0.928, -1.347,  0.127,
             0.928,  1.347,  0.127,
            -0.928,  1.347,  0.127,
            // Top
            -0.928,  1.347,  0.127,
             0.928,  1.347,  0.127,
             0.928,  1.347, -0.127,
            -0.928,  1.347, -0.127,
            // Bottom
            -0.928, -1.347, -0.127,
             0.928, -1.347, -0.127,
             0.928, -1.347,  0.127,
            -0.928, -1.347,  0.127,
            // Right
             0.928, -1.347,  0.127,
             0.928, -1.347, -0.127,
             0.928,  1.347, -0.127,
             0.928,  1.347,  0.127,
            // Left
            -0.928, -1.347, -0.127,
            -0.928, -1.347,  0.127,
            -0.928,  1.347,  0.127,
            -0.928,  1.347, -0.127
        ],
        element: [
            // Front
             0,  1,  2,
             0,  2,  3,
            // Top
             4,  5,  6,
             4,  6,  7,
            // Bottom
             8,  9, 10,
             8, 10, 11,
            // Right
            12, 13, 14,
            12, 14, 15,
            // Left
            16, 17, 18,
            16, 18, 19,
        ],
        texture: [
            // Front
            0.157, 0.879,
            0.843, 0.879,
            0.843, 0.121,
            0.157, 0.121,
            // Top
            0.157, 0.121,
            0.843, 0.121,
            0.843, 0.050,
            0.157, 0.050,
            // Bottom
            0.157, 0.950,
            0.843, 0.950,
            0.843, 0.879,
            0.157, 0.879,
            // Right
            0.843, 0.879,
            0.937, 0.879,
            0.937, 0.121,
            0.843, 0.121,
            // Left
            0.063, 0.879,
            0.157, 0.879,
            0.157, 0.121,
            0.063, 0.121
        ],
        svgReference: svgReference,
        updateFrequency: 'regular',
        vertexNormal: [
            // Front
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            0.0,  0.0,  1.0,
            // Top
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            // Bottom
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            // Right
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            // Left
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0
        ],
      },
      boxBottom: {
        position: [
            // Back
            -0.927, -1.346, -0.333,
            -0.927,  1.346, -0.333,
             0.927,  1.346, -0.333,
             0.927, -1.346, -0.333,
            // Top
            -0.927,  1.346,  0.127,
             0.927,  1.346,  0.127,
             0.927,  1.346, -0.333,
            -0.927,  1.346, -0.333,
            // Bottom
            -0.927, -1.346, -0.333,
             0.927, -1.346, -0.333,
             0.927, -1.346,  0.127,
            -0.927, -1.346,  0.127,
            // Right
             0.927, -1.346,  0.127,
             0.927, -1.346, -0.333,
             0.927,  1.346, -0.333,
             0.927,  1.346,  0.127,
            // Left
            -0.927, -1.346, -0.333,
            -0.927, -1.346,  0.127,
            -0.927,  1.346,  0.127,
            -0.927,  1.346, -0.333
        ],
        element: [
            // Back
             0,  1,  2,
             0,  2,  3,
            // Top
             4,  5,  6,
             4,  6,  7,
            // Bottom
             8,  9, 10,
             8, 10, 11,
            // Right
            12, 13, 14,
            12, 14, 15,
            // Left
            16, 17, 18,
            16, 18, 19,
        ],
        texture: [
            // Back
            0.802, 0.847,
            0.802, 0.154,
            0.197, 0.154,
            0.197, 0.847,
            // Top
            0.802, 0.011,
            0.197, 0.011,
            0.197, 0.154,
            0.802, 0.154,
            // Bottom
            0.802, 0.847,
            0.197, 0.847,
            0.197, 0.99,
            0.802, 0.99,
            // Right
            0.014, 0.847,
            0.197, 0.841,
            0.197, 0.154,
            0.014, 0.154,
            // Left
            0.802, 0.847,
            0.985, 0.847,
            0.985, 0.154,
            0.802, 0.154,
        ],
        svgReference: getBackSVG(getOrientation(svgReference)),
        updateFrequency: 'startup',
        vertexNormal: [
            // Back
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            0.0,  0.0, -1.0,
            // Top
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            0.0,  1.0,  0.0,
            // Bottom
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            0.0, -1.0,  0.0,
            // Right
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            1.0,  0.0,  0.0,
            // Left
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0,
            -1.0,  0.0,  0.0
        ],
      }
    };
    super(canvas, model, options);
  }
}
